<div class="lm-builder-display-field-container form-layout-compact">
@if (displayField) {
        <!--FORM TEXT-->
        @if (displayField.type === 'formText' && formTextSpec) {
                @if (formTextSpec) {
                    <div class="field">
                        <label soho-label for="lm-display-field-form-text-message">{{ 'FormText' | translate }}</label>
                        <input
                            id="lm-display-field-form-text-message"
                            data-automation-id="lm-display-field-form-text-messageinput"
                            soho-input
                            soho-trackdirty
                            readonly=" true"
                            [(ngModel)]="formTextSpec.messageRule.messageRule">
                    </div>
                }
        }
        <!--LABEL-->
        @if (displayField.type === 'field' || displayField.type === 'button'
        || displayField.type === 'checkControl' || displayField.type === 'multiSelect') {
            @if (displayField.groupLabel) {
                <div class="field">
                    <label soho-label for="lm-display-field-group-label">{{ 'GroupLabel' | translate }}</label>
                    <input
                        id="lm-display-field-group-label"
                        data-automation-id="lm-builder-display-field-group-label-input"
                        soho-input
                        soho-trackdirty
                        class=""
                        [(ngModel)]="groupLabel"
                        (ngModelChange)="updateGroupLabel()">
                </div>
            }
            <div class="field">
                <label soho-label for="lm-display-field-label">{{ 'Label' | translate }}</label>
                <input
                    id="lm-display-field-label"
                    data-automation-id="lm-builder-display-field-label-input"
                    soho-input
                    soho-trackdirty
                    class="full-width-100"
                    [(ngModel)]="label"
                    (ngModelChange)="updateLabel()">
            </div>
        }
        <!--FIELD-->
        @if (displayField.type === "field" && fieldSpec)  {
            @if (fieldSpec.inlineCompute) {
                <div class="field">
                    <label class="required" soho-label for="lm-display-field-compute">{{ 'Compute' | translate }}</label>
                    <textarea
                            id="lm-display-field-compute"
                            data-automation-id="lm-display-field-compute"
                            spellcheck="false"
                            soho-textarea
                            soho-alert
                            soho-trackdirty
                            cdkDropList
                            data-validate="validateRequired"
                            class="full-width-100"
                            [(ngModel)]="fieldSpec.fieldId"
                            (focusout)="validateComputeInParens()"
                            (ngModelChange)="this.computeFieldValidator$.next($event)"></textarea>
                </div>
                <div>
                    <div class="lm-build-compute">
                        <button
                            id="lm-builder-compute-builder-link"
                            data-automation-id="lm-builder-compute-builder-link"
                            soho-button="tertiary"
                            (click)="openComputeBuilder()">{{ 'Builder' | translate }}</button>
                    </div>
                </div>
                <div class="field">
                    <label soho-label for="lm-display-field-decimal-size">{{ 'DecimalSize' | translate }}</label>
                    <input
                            id="lm-display-field-decimal-size"
                            data-automation-id="lm-display-field-decimal-size-input"
                            soho-input
                            type="number"
                            min="0"
                            max="10"
                            soho-trackdirty
                            class="input-xs"
                            [(ngModel)]="fieldSpec.numberOfDecimals">
                </div>
            } @else {
                <div class="field">
                    <label soho-label for="lm-display-field-id">{{ 'FieldID' | translate }}</label>
                    <input
                            id="lm-display-field-id"
                            data-automation-id="lm-builder-display-field-id-input"
                            soho-input
                            soho-trackdirty
                            readonly = true
                            class="full-width-100"
                            [(ngModel)]="fieldSpec.fieldId">
                </div>
            }
            @if(enableOperatorForActor && supportsOperator && !fieldSpec.inlineCompute) {
                <div class="lm-build-compute">
                    <button
                        soho-button="tertiary"
                        data-automation-id="lm-builder-display-field-edit-operator-btn"
                        (click)="editOperator()">{{ editOperatorLabel}}</button>
                </div>
            }
            @if (fieldSpec.allowUpdate.allowUpdate || fieldSpec.canUpdate) {
                <div class="field">
                    <input
                        soho-checkbox
                        type="checkbox"
                        id="lm-builder-display-field-allow-update"
                        data-automation-id="lm-builder-display-field-allow-update-input"
                        soho-trackdirty
                        [(ngModel)]="allowUpdate"
                        [disabled]="!canUpdate"
                        (change)="updateAllowUpdate()">
                    @if (allowUpdateWhen) {
                        <label soho-label for="lm-builder-display-field-allow-update" [forCheckBox]="true" data-automation-id="lm-builder-display-field-allow-update-label">{{ 'AllowUpdateWhen' | translate }} {{allowUpdateWhen}}</label>
                    } @else {
                        <label soho-label for="lm-builder-display-field-allow-update" [forCheckBox]="true" data-automation-id="lm-builder-display-field-allow-update-label">{{ 'AllowUpdate' | translate }}</label>
                    }
                    @if (allowUpdateMessage && allowUpdate) {
                        <div class="info-message">
                            <svg soho-icon [icon]="'info'" class="icon-info icon" ></svg>
                            <p class="message-text" data-automation-id="lm-builder-display-field-allow-update-message">{{allowUpdateMessage}}</p>
                        </div>
                    }
                </div>
            }
            @if(fieldSpec.canTotal) {
                <div class="field">
                    <label soho-label for="lm-builder-display-field-total">{{ 'ColumnEditorColumnTotalingLabel' | translate }}</label>
                    <select
                        soho-dropdown
                        soho-trackdirty
                        id="lm-builder-display-field-total"
                        name="lm-builder-display-search"
                        data-automation-id="lm-builder-display-field-total-dropdown"
                        [attributes]="totalIDSAttributes"
                        [disabled]="!canTotal"
                        [(ngModel)]="fieldSpec.total"
                        (change)="updateTotal()">
                        @for (totalType of totalTypes; track totalType.value) {
                            <option [value]=totalType.value>{{totalType.label}}</option>
                        }
                    </select>
                </div>
            }
        }
        <!--SORTING AND ALERTS-->
        @if (displayField.type === 'field' || displayField.type === 'button') {
            <soho-accordion [allowOnePane]="true" [expanderDisplay]="'chevron'">
                @if (displayField.type === 'field') {
                    <soho-accordion-header id="sorting" class="lm-builder-property-header"><a href="#"><span>{{ 'Sorting' | translate }}</span></a></soho-accordion-header>
                    <soho-accordion-pane class="lm-builder-accordion-pane"><lm-builder-display-field-sorting [spec]="spec" [displayField]="displayField" [fieldSpec]="fieldSpec"></lm-builder-display-field-sorting></soho-accordion-pane>
                }
                <soho-accordion-header id="alerts" class="lm-builder-property-header"><a href="#"><span>{{ 'Alerts' | translate }}</span></a></soho-accordion-header>
                <soho-accordion-pane class="lm-builder-accordion-pane"><lm-builder-display-field-alerts [spec]="spec" [displayField]="displayField" [fieldSpec]="fieldSpec"></lm-builder-display-field-alerts></soho-accordion-pane>
            </soho-accordion>
        }
    } @else {
        <p>display field not defined</p>
    }
</div>
